import RmCard from './RmCard';
import styles from './RmCardsGroup.module.scss';
import PropTypes from 'prop-types';
import {
    RMCardGroupDataType,
    RMCardGroupTooltipType,
    TopFiveRmsCategory
} from 'types/types';

const RmCardsGroup = (props) => {
    const {
        breachCategory,
        width = '50%',
        data,
        dataType = RMCardGroupDataType.Default,
        title,
        subTitle,
        upperRightContent,
        footerText = '',
        isLeftGroup = false,
        isRightGroup = false,
        tooltipType = RMCardGroupTooltipType.Default,
        isScrollable = false,
        isBottomGroup = false,
        navigateTo
    } = props;
    const hasData = data && data.length > 0;
    return (
        <div
            className={`${styles.wrapper} ${isLeftGroup && styles.leftGroup} ${
                isRightGroup && styles.rightGroup
            }`}
            style={{
                width: width,
                justifyContent: hasData ? 'center' : 'space-between'
            }}
        >
            <div className={styles.titleContainer}>
                <p className={styles.titleTextContainer}>
                    <span className={styles.titleText}>{title}&nbsp;</span>
                    <span className={styles.subTitleText}>{subTitle}</span>
                </p>
                {upperRightContent && (
                    <div className={styles.upperRightContent}>
                        {upperRightContent}
                    </div>
                )}
            </div>
            <div
                className={
                    isScrollable
                        ? styles.scrollableCardsContainer
                        : styles.cardsContainer
                }
            >
                {hasData ? (
                    data.map((rmData, idx) => (
                        <RmCard
                            key={`${subTitle}-${footerText}-${idx}`}
                            rmData={rmData}
                            dataType={dataType}
                            breachCategory={
                                breachCategory ===
                                TopFiveRmsCategory.Concentration
                                    ? 'Concentration Risk'
                                    : 'Portfolio Risk Mismatch'
                            }
                            tooltipType={tooltipType}
                            isLastCardInGroup={idx === data.length - 1}
                            isBottomGroup={isBottomGroup}
                            navigateTo={navigateTo}
                        />
                    ))
                ) : (
                    <div className={styles.noDataContainer}>
                        No RMs Applicable
                    </div>
                )}
            </div>
            <div className={styles.footerContainer}>
                {typeof footerText === 'object' && Array.isArray(footerText) ? (
                    <div className={styles.multipleFooterTextContainer}>
                        {footerText.map((text, idx) => {
                            return (
                                <div
                                    key={`footerText-${text}-${idx}`}
                                    className={styles.footerText}
                                >
                                    {text}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className={styles.multipleFooterTextContainer}>
                        <p className={styles.footerText}>{footerText}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

RmCardsGroup.propTypes = {
    breachCategory: PropTypes.oneOf(['concentration', 'portfolio']),
    width: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            rmEmployeeId: PropTypes.string,
            totalAlerts: PropTypes.number,
            percentAlerts: PropTypes.number,
            rank: PropTypes.number,
            score: PropTypes.number,
            rmRegion: PropTypes.string,
            rmGroup: PropTypes.string,
            color: PropTypes.oneOf(['grey', 'green', 'yellow', 'red'])
        })
    ),
    dataType: PropTypes.oneOf([
        'default',
        'topFiveRms',
        'topFiveEmergingModerateRm',
        'topFiveEmergingMajorRm',
        'topFiveRmsSpike',
        'alerts'
    ]),
    title: PropTypes.string,
    subTitle: PropTypes.string,
    footerText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    tooltipType: PropTypes.oneOf([
        'default',
        'scoreDecomposition',
        'trendAnalysis'
    ]),
    upperRightContent: PropTypes.element,
    isScrollable: PropTypes.bool,
    isLeftGroup: PropTypes.bool,
    isRightGroup: PropTypes.bool,
    isBottomGroup: PropTypes.bool,
    navigateTo: PropTypes.func
};

export default RmCardsGroup;
